module.exports = __webpack_public_path__ + "img/swing-ic.a1cb4be8.png";